var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1200 1200",
    style: {
      enableBackground: "new 0 0 1200 1200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#222222;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1080.9,252H1020v-24H912v24H792V132c0-14.2-13.1-24-27.3-24H429.8c-14.2,0-21.8,9.8-21.8,24v120H276v-24h-96 v24h-66.4C55.2,252,12,305.2,12,363.5v648.9c0,58.3,43.2,103.6,101.6,103.6h967.4c58.4,0,107.1-45.3,107.1-103.6V363.5 C1188,305.2,1139.3,252,1080.9,252L1080.9,252z M204,1092V264h48v828H204z M732,252H456v-96h276V252z M936,1092V264h60v828H936z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/Bag.41f6333ee179c6c92a6e3bc917c39fc2.svg";
export { ForwardRef as ReactComponent };